/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
export function ActionButtons({
  items,
  onClose,
}: {
  items: Array<{
    label: string;
    onSelect: () => Promise<void>;
    icon: JSX.Element;
  }>;
  onClose: () => void;
}) {
  async function handleSelect(onSelect: () => Promise<void>) {
    onClose();
    await onSelect();
  }

  return (
    <div className="flex flex-col space-y-3">
      <ul className="flex flex-col gap-1 pb-2">
        {items.map(item => (
          <li className="w-full pt-2" key={item.label}>
            <div
              onClick={() => handleSelect(item.onSelect)}
              className="flex w-full items-center gap-4 h-12 p-2 rounded-sm text-sm hover:bg-[#ededef] transition-all duration-100 ease-linear cursor-pointer"
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
